import styled from 'styled-components'

export const DropdownButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  outline: inherit;
  padding-right: 0;
`

export const NotFoundInfo = styled.div`
  display: flex;
  justify-content: center;
  font-size: 1rem;
  text-align: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const HeadSection = styled.section`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  .title {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.1;
  }

  .label-line {
    font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.darkGrey};
    line-height: 1.1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
  }
`

export const InfoSection = styled.section`
  width: 100%;
`

export const WrapperTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
`

export const TagsInfo = styled.div`
  border-radius: 8px;
  padding: 0.3rem 1rem;
  background-color: transparent;
  color: black;
  font-weight: 700;
  font-size: 0.8rem;
  display: flex;
  gap: 0.3rem;
  text-transform: uppercase;
`

export const WrapperInfo = styled.section`
  margin: 0.3rem 0;

  h5 {
    margin: 1rem 0;
  }

  p {
    text-align: justify;
  }
`

export const WrapperWarnings = styled.small``
